import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=ef14fef4&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=js&"
export * from "./Health.vue?vue&type=script&lang=js&"
import style0 from "./Health.vue?vue&type=style&index=0&id=ef14fef4&scoped=true&lang=css&"
import style1 from "./Health.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef14fef4",
  null
  
)

export default component.exports